import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { BsExclamationTriangleFill } from "react-icons/bs";
import "./ResetProgressModal.scss";

type OptOutMarketingModalProps = {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void | Promise<void>;
  isSaving?: boolean;
};

const OptOutMarketingModal = ({
  show,
  onHide,
  onConfirm,
  isSaving = false,
}: OptOutMarketingModalProps) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="reset-progress-modal"
    >
      <Modal.Header closeButton closeLabel="Close">
        <Modal.Title>Stop marketing emails?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="reset-progress-modal__alert">
          <BsExclamationTriangleFill
            className="reset-progress-modal__icon"
            aria-hidden
          />
          <div>
            <p className="reset-progress-modal__lead">
              You&apos;ll miss out on useful updates from us.
            </p>
            <p className="reset-progress-modal__text">
              We only send occasional messages — never spam — and you can
              always opt back in later from Settings.
            </p>
          </div>
        </div>

        <ul className="reset-progress-modal__list">
          <li>Promotions and discount offers</li>
          <li>Product updates and new features</li>
          <li>News about question banks and exams</li>
        </ul>

        <p className="reset-progress-modal__note">
          <strong>Note:</strong> you&apos;ll still receive important account
          emails such as receipts and password resets.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSaving}>
          Keep me updated
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isSaving}>
          {isSaving ? "Updating…" : "Opt out"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OptOutMarketingModal;
